export const message = {
  officialAnswer: "官方答案",
  answerCheckedMessage: "成功标记答案",
  setOfficialAnswerContent: "确定将此答案标记为官方答案吗？",
};
